import { useFetchCustomUserRoles } from '@app/modules/Admin/hooks/useCustomUserRoles'
import { DOCUMENT_ROLE_LABELS_MAP, DOCUMENT_SELECTABLE_ROLES } from '../documents.constants'

export type DocumentRoleOption = { id: string; label: string }

// Shared by the Permissions step and the document preview so both use the same labels.
export const useDocumentRoleOptions = (): DocumentRoleOption[] => {
  const { data: customRoles } = useFetchCustomUserRoles()

  return [
    ...DOCUMENT_SELECTABLE_ROLES.map((role) => ({
      id: role as string,
      label: (DOCUMENT_ROLE_LABELS_MAP as Record<string, string>)[role] ?? role,
    })),
    ...(customRoles ?? []).map((role) => ({
      id: role.name.toLowerCase(),
      label: role.name,
    })),
  ]
}
